import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import { AUTH_LOGOUT } from '../actions/auth'
import AuthService from '@/services/AuthService'

const state = {
  user: {},
  status: ''
}

const getters = {
  getUser: state => state.user,
  isLoggedIn: state => !!state.user.Brukerid
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      AuthService.profile()
        .then(response => {
          // Success
          commit(USER_SUCCESS, response.data)
          resolve(response)
        })
        .catch(error => {
          // Failure
          dispatch(AUTH_LOGOUT)

          commit(USER_ERROR)
          reject(error)
        })
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, user) => {
    state.status = 'success'
    state.user = user
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
    state.user = {}
  },
  [AUTH_LOGOUT]: (state) => {
    console.log('Unset user')
    state.status = 'success'
    state.user = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js